export default "__VITE_ASSET__CwVt7RmS__"